import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StyleCocheSeguro } from 'src/app/modelos/styleCocheseguro.model';
import { StorageService } from 'src/app/services/storage.service';
import { Configuration } from '../../Constants/configuration';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent {
    public styleCocheSeguro:StyleCocheSeguro = new StyleCocheSeguro();
    public const: Configuration = new Configuration();

    constructor(private router: Router, private storageService: StorageService) {
        if (this.storageService.ifExist("styleCocheSeguro")) {
            this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
        }
    }

    ngOnInit(){
    }

    openWindow(event) {
        switch (event) {
            case 1:
                window.open("https://seguros.inter.mx/servicios/#seguros"); // Seguros y Fianzas
                break;
            case 3:
                window.open("https://seguros.inter.mx/servicios/#reaseguro"); // Reaseguro
                break;
            case 4:
                window.open("https://seguros.inter.mx/servicios/#microseguros"); // Microseguros
                break;
            case 5:
                window.open("https://inter.mx/servicios/"); // Líneas financieras
                break;
            case 6:
                window.open("https://seguros.inter.mx/servicios/#solucionestpa"); // Soluciones TPA
                break;
            case 7:
                // Seguro de coche
                if (this.const.PLATFORM) {
                    window.location.href = this.const.URLPLATFORM + 'inicio';
                } else {
                    this.router.navigate(['/inicio']);
                }
                break;
            case 8:
                window.open("https://medicoseguro.inter.mx/"); // Gastos Médicos Mayores
                break;
            case 9:
                window.open("https://productos.inter.mx/bien-seguro/"); // Tu casa y sus contenidos
                break;
            case 10:
                window.open("https://seguros.inter.mx/seguro-covid-protect-inter/"); // Seguro Covid
                break;
            case 11:
                window.open("tel:5544246837"); // telefono
                break;
            case 12:
                window.open("mailto:hola@inter.mx"); // email
                break;
            case 13:
                window.open("https://www.interbi.mx/qlikview/FormLogin.htm"); // login
                break;
            case 14:
                window.open("https://inter.mx/aviso-de-privacidad"); // aviso de privacidad
                break;
            case 15:
                window.open("https://www.facebook.com/interproteccionmx/"); // facebook
                break;
            case 16:
                window.open("https://www.instagram.com/interproteccion/"); // instagram
                break;
            case 17:
                window.open("https://www.linkedin.com/company/interproteccion/"); // linkedin
                break;
            case 18:
                window.open("https://cocheseguro.inter.mx/inicio");
                break;
            case 19:
                window.open("https://mascotasegura.inter.mx/seguro-mascota/landing");
                break;
            case 20:
                window.open("https://productos.inter.mx/vida-segura/");
                break;
            case 21:
                window.open("https://www.youtube.com/channel/UCZ8wH2JLzDYvvrN-JiG3roA");
                break;
            case 22:
                window.open("https://vm.tiktok.com/ZMeSRnwDw/");
                break;
        }
    }

}
